'use es6';

import { useState } from 'react';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.withNameModal.${key}`;
const getDefaultFormName = defaultFormNamePrefix => defaultFormNamePrefix ? unescapedText(i18nKey('defaultFormName'), {
  pageTitle: defaultFormNamePrefix,
  timestamp: I18n.moment().portalTz().format('LL LTS z')
}) : '';
const Header = ({
  onCloseClick,
  headerText
}) => /*#__PURE__*/_jsxs(DialogHeader, {
  children: [/*#__PURE__*/_jsx(DialogCloseButton, {
    onClick: onCloseClick
  }), /*#__PURE__*/_jsx(H2, {
    children: headerText
  })]
});
const Body = ({
  isConflictError,
  name,
  onNameChange
}) => /*#__PURE__*/_jsx(DialogBody, {
  children: /*#__PURE__*/_jsx(FormControl, {
    error: isConflictError,
    validationMessage: isConflictError && /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('error.conflict')
    }),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('name')
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      value: name,
      onChange: ({
        target: {
          value
        }
      }) => onNameChange(value)
    })
  })
});
const Footer = ({
  isCreating,
  onCreateClick,
  onCancelClick,
  createText,
  isCreateDisabled
}) => /*#__PURE__*/_jsxs(DialogFooter, {
  children: [/*#__PURE__*/_jsx(LoadingButton, {
    loading: isCreating,
    onClick: onCreateClick,
    disabled: isCreateDisabled,
    use: "primary",
    children: createText
  }), /*#__PURE__*/_jsx(Button, {
    onClick: onCancelClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('cancel')
    })
  })]
});
const CreateFormWithNameModal = ({
  defaultFormNamePrefix = '',
  isCreating = false,
  isConflictError = false,
  onCreateClick = () => {},
  onCancelClick = () => {},
  headerText = '',
  createText = ''
}) => {
  const [name, setName] = useState(getDefaultFormName(defaultFormNamePrefix));
  return /*#__PURE__*/_jsxs(Modal, {
    "data-selenium": "form-create-modal",
    children: [/*#__PURE__*/_jsx(Header, {
      onCloseClick: onCancelClick,
      headerText: headerText
    }), /*#__PURE__*/_jsx(Body, {
      name: name,
      isConflictError: isConflictError,
      onNameChange: setName
    }), /*#__PURE__*/_jsx(Footer, {
      isCreating: isCreating,
      onCreateClick: () => onCreateClick(name),
      onCancelClick: onCancelClick,
      createText: createText,
      isCreateDisabled: name.length === 0
    })]
  });
};
export default CreateFormWithNameModal;